export default "__VITE_ASSET__BpKee5OG__"